import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        info: {
            addr: '',
            canvasheight: 0,
            canvaswidth: 0,
            pngaddr: '',
            jpgaddr: '',
            host: '',
            initX: 0,
            initY: 0,
            rate: 1,
            showheight: 0,
            showwidth: 0
        }
    },
    mutations: {
        setinfo(state, value) {
            state.info = value;
        },
        setdownaddr(state, value) {
            state.info.pngaddr = value.png;
            state.info.jpgaddr = value.jpg;
        }
    },
    actions: {

    }
})